module.exports = __webpack_public_path__ + "static/media/hm-closed.cf9835a1.svg";